module.exports = __webpack_public_path__ + "static/media/User-icon.49e5a196.svg";